export const contractorFields = [
  {
    id: "7dc69729-e4r9-4e91-9842-15d845a590d7",
    type: "contractor-violations-table",
    label: "Список нарушений",
    content: {
      required: false,
    },
    variable: "violationDescription",
    helperText: "",
    sequenceNumber: 1,
  },
  {
    id: "7dc69729-e2f9-4e91-9842-15d845a590d7",
    type: "multiline-text-field",
    label: "Описание нарушения",
    content: {
      required: false,
    },
    disabled: true,
    variable: "violationName",
    inputProps: {
      readOnly: true,
    },
    helperText: "",
    sequenceNumber: 2,
  },
  {
    id: "7tg69729-e2f9-4e91-9842-15d845a590d7",
    type: "chip-block",
    variable: "violationFiles",
    helperText: "",
    sequenceNumber: 3,
  },
  {
    id: "7dc69729-e2f9-4e91-9842-15d823a590d7",
    type: "removal-date-time",
    label: "Дата и время устранения нарушения",
    content: {
      required: true,
    },
    variable: "removalDate",
    helperText: "",
    sequenceNumber: 4,
  },
  {
    id: "7dc69729-e2f9-4e91-9842-15df25a590d7",
    type: "multiline-text-field",
    label: "Описание устраненного нарушения",
    content: {
      required: true,
    },
    variable: "removalDescription",
    helperText: "",
    sequenceNumber: 5,
  },
  {
    id: "b5c09e26-4f8f-4895-85b3-f9246f3d8aa5",
    type: "drag-and-drop-act-upload",
    label: "Загрузить файл",
    content: {
      required: false,
    },
    variable: "removalFiles",
    helperText: "",
    sequenceNumber: 6,
  },
  {
    id: "b5c09e26-5t4f-4895-85b3-f9246f3d8aa5",
    type: "checkbox-field",
    label: "Подтвердить статус исправленного нарушения",
    content: {
      required: true,
    },
    variable: "removalStatus",
    helperText: "",
    sequenceNumber: 7,
  },
];